import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import type { Playlist } from "../../model/launchpad";
import TileSection from "./TileSection";
import PlaylistTile from "./PlaylistTile";
import { ListMusicIcon } from "../ui/icons";

// Web port of PlaylistListView
// (HomeFeature/View/Component/PlaylistListView.swift).
//
// Identical in shape to WorshipSongsSection — same TileSection, different icon,
// title, and tile — which is the reuse the app relies on.

export interface PlaylistsSectionProps {
  playlists: Playlist[];
  /**
   * Overrides the default tap behaviour. Left unset, tapping a playlist opens
   * its detail page, the way PlaylistTileButton navigates in the app.
   */
  onPlaylistClick?: (playlist: Playlist) => void;
  usesGrid?: boolean;
}

export default function PlaylistsSection(props: PlaylistsSectionProps) {
  const { t } = useTranslation("library");
  const navigate = useNavigate();
  const handleClick = props.onPlaylistClick
    ?? ((playlist: Playlist) => navigate(`/playlist/${playlist.id}`));

  return <TileSection
    icon={<ListMusicIcon />}
    title={t("playlists")}
    items={props.playlists}
    getKey={(playlist) => playlist.id}
    usesGrid={props.usesGrid}
    renderTile={(playlist, tileWidth) => (
      <PlaylistTile
        title={playlist.attributes.name}
        subtitle={t("songCount", { count: playlist.songs.length })}
        // PlaylistTileButton: playlist.songs.compactMap(\.attributes.artworkURL)
        artworkUrls={playlist.songs
          .map((song) => song.attributes.artworkURL)
          .filter((url): url is string => url !== null)}
        width={tileWidth}
        onClick={() => handleClick(playlist)}
      />
    )}
  />
}
